import React, { useContext } from 'react';
import UserProvider from '../../context/UserContext';
import '../../dash.css'

const CardPlan = () => {
    const Data = useContext(UserProvider.context);
    const memberData = Data.member
    
    let date;
    let renewaldate;
    if(memberData.next_renewal_date == null || memberData.subscription_active == false){
        date = '';
        renewaldate = '';
    }
    else{
        renewaldate = 'Next renewal date';
        date = memberData.next_renewal_date;
    }

    let status;
    if(memberData.subscription_active == true){
        status = "Active"
    }
    else{
        status = "Inactive"
    }

    return(
        <div className="card-component">
            <div className="card-content row-container">
                <div>
                    <h4 className="card-title">Payment plan</h4>
                    <div className="price">
                        <h1>{memberData.monthly}€<span>/month</span></h1>
                    </div>
                    <span className="tag">{status}</span>
                </div>
                <div className="date">
                    <h4>{renewaldate}</h4>
                    <h5>{date}</h5>
                </div>
            </div>
        </div>
    )
};

export default CardPlan;